import "bootstrap/dist/css/bootstrap.min.css";
import {Box, Button, Typography} from '@mui/material';
import {useLanguage} from "../LanguageContext";
import UpcomingGroupTourSections from "../components/./tours/UpcomingGroupTourSections";
import "../App.css";

import {videoStyle} from "../components/styles/IntroSectionStyles";
import backgroundVideo from "../video/home-background.mp4";
import React, {useEffect, useState} from "react";
import AboutUsSection from "../components/home/AboutUsSection";
import {PageTitle} from "../components/PageTitle";
import FeedbackSection from "../components/feedback/FeedbackSection";
import ContactSection from "../components/contact/ContactSection";
import {
    mainLogoStyle,
    mainPageSubtitle,
    readyToTravel,
    readyToTravelContainer,
    textBoxStyle
} from "../components/styles/HomePageStyles";
import ReactGA from "react-ga4";


const Top = ({setOpen}) => {
    const {t} = useLanguage();

    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                height: {xs: "100vh", md: '100vh'},
                overflow: "hidden",
            }}
        >
            <PageTitle title={'label_main'}/>
            <video autoPlay
                   loop
                   muted
                   playsInline
                   webkit-playsinline
                   preload="auto"
                   style={videoStyle}>
                <source
                    src={backgroundVideo} type="video/mp4"/>
            </video>

            <Box sx={textBoxStyle}>
                <Box sx={mainLogoStyle}/>
                <Typography
                    sx={mainPageSubtitle}>
                    {t('home_main_subtext')}
                </Typography>

            </Box>
            <Box
                sx={readyToTravelContainer}>
                <Button
                    // variant="outlined"
                    onClick={() => setOpen(true)}
                    sx={readyToTravel}
                >
                    {t('button_ready_to_travel').toUpperCase()}
                </Button>
            </Box>
        </Box>
    );
};


const Home = () => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname })
    }, []);

    return (
        <Box>
            <Top setOpen={setOpen}/>
            <AboutUsSection/>
            <UpcomingGroupTourSections titleVariant="black"/>
            <FeedbackSection/>
            <ContactSection open={open} setOpen={setOpen}/>
        </Box>
    );
}

export default Home;
